const {PlatMd5} = require("./platMd5");
const {enc, AES, mode, pad} = require("crypto-js");

exports.paramSecret = function (params, isH5 = false) {
    let AppConfig = {
        appId: '100005',
        gameId: '0',
        //开发
        //infoAppSecret: 'AD5C9B084E2C5E78C9F6BBE6FD57B7DA',
        //测试
        //infoAppSecret: 'AD5C9B084E2C5E78C9F6BBE6FD57B7DA',
        //正式
        infoAppSecret: 'EFD1A2F9B0B5F14B1FAC70A7F8E8A9E7',
        deviceId: '1',
        unionId: '1',
        siteId: '0',
        userIp: '',
        version: '1.0.0',
        terminalSource: 2,
    }
    let commonParam = {}
    for (let item in AppConfig) {
        if (item !== 'infoAppSecret') {
            commonParam[item] = AppConfig[item];
        }
    }
    let appBaseInfoStr = localStorage.getItem("appBaseInfo");
    if (appBaseInfoStr !== undefined && appBaseInfoStr !== null) {
        let appBaseInfo = JSON.parse(appBaseInfoStr);
        for (let info in appBaseInfo) {
            if (info === 'unionId' || info === 'siteId') {
                commonParam[info] = appBaseInfo[info];
            }
        }
    }
    for (let key in params) {
        commonParam[key] = params[key];
    }
    let keyStr = "appid=" + AppConfig.appId + "&" + getParamStr(commonParam, ["appId", "sign"]) + "&appsecret=" + AppConfig.infoAppSecret;
    commonParam.sign = PlatMd5.hashStr(keyStr).toUpperCase();
    let finalParasJson = {};
    finalParasJson.data = customEncrypt(commonParam, commonParam.appId, AppConfig.infoAppSecret);
    return finalParasJson;
}

function customEncrypt(commonParam, appId, appSecret) {
    let requestParas = JSON.stringify(commonParam);
    let wordArray;
    try {
        wordArray = enc.Utf8.parse(requestParas);
    } catch (e) {
        console.log("请引入jsLib中aes.js作为插件");
    }
    let base64Request = enc.Base64.stringify(wordArray);
    //固定32位字符串
    let customKey = "jasdvvsagasvaekgvixvbjadhvfhjeww";
    //取前两位0-16的数字
    let rd = Math.floor(Math.random() * 16);
    let strRd = String(rd);
    if (strRd.length < 2) {
        strRd = "0" + strRd;
    }
    //密钥key
    let key = appSecret.toLowerCase().substring(rd, rd + 16);
    let desValue = encryptByAES(base64Request, key);
    let secondCustomKey = customKey.substring(0, 6) + strRd + customKey.substring(6);
    let thirdCustomKey = secondCustomKey.substring(0, 23) + commonParam.appId + secondCustomKey.substring(23);
    return desValue + thirdCustomKey;
}

function encryptByAES(message, key) {
    key = enc.Utf8.parse(key);
    let secretUtf8 = enc.Utf8.parse(message);
    let encrypted = AES.encrypt(secretUtf8, key, {mode: mode.ECB, padding: pad.Pkcs7});
    return encrypted.toString();
}

function getParamStr(d, excludeKeys) {
    let keyList = [];
    for (let key in d) {
        if (!d[key] && d[key] !== 0)
            continue;
        if (excludeKeys && excludeKeys.indexOf(key) !== -1)
            continue;
        keyList.push(key);
    }
    keyList.sort();
    let stringA = "";
    for (let i = 0; i < keyList.length; i++) {
        if (i === keyList.length - 1) {
            stringA += keyList[i] + "=" + d[keyList[i]];
        } else {
            stringA += keyList[i] + "=" + d[keyList[i]] + "&";
        }
    }
    return stringA;
}

exports.base64Encode = function (params) {
    let baseString = enc.Utf8.parse(params);
    return enc.Base64.stringify(baseString);
}

exports.base64Des = function (params) {
    return enc.Base64.parse(params).toString(enc.Utf8);
}

exports.md5String = function (params) {
    return PlatMd5.hashStr(params);
}
